module.exports = __webpack_public_path__ + "img/BZ.a4b52ad2.svg";